import { ReactElement } from 'react';

import { useUIConfiguration } from '@cashier/cashier-shared';
import { Button, Loader } from '@cashier/cashier-ui';

import { useSubmitButton } from '../hooks';

import styles from './styles.module.scss';

interface SubmitButtonProps {
  onClick: () => void;
}

export const SubmitButton = ({ onClick }: SubmitButtonProps): ReactElement => {
  const buttonBackground = useUIConfiguration('button', 'background');
  const buttonType = useUIConfiguration('button', 'type');
  const { title, isDisabled, isLoading } = useSubmitButton();

  return (
    <Button
      onClick={onClick}
      isDisabled={isDisabled}
      backgroundType={buttonBackground}
      type={buttonType}
    >
      {isLoading && (
        <div className={styles.loader}>
          <Loader size="small" theme="colored" />
        </div>
      )}
      {!isLoading && title && <span className={styles.text}>{title}</span>}
    </Button>
  );
};
